<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sofa`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 4a2 2 0 012 2v9h3a2 2 0 012 2v22a2 2 0 01-2 2h-5v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4H13v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4H4a2 2 0 01-2-2V17a2 2 0 012-2h3V6a2 2 0 012-2h30zM12 19H6v18h36V19h-6v11H12V19zM37 8H11v7h3a2 2 0 012 2v9h16v-9a2 2 0 012-2h3V8z"/></svg>
</template>
<script>

export default {
  name: 'IconSofa',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
